import { render, staticRenderFns } from "./SelectedArticleInfo.vue?vue&type=template&id=7ee60686&"
import script from "./SelectedArticleInfo.vue?vue&type=script&lang=js&"
export * from "./SelectedArticleInfo.vue?vue&type=script&lang=js&"
import style0 from "./SelectedArticleInfo.vue?vue&type=style&index=0&id=7ee60686&prod&lang=sass&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports